import { IDocumentImageSource } from "../IDocumentImageSource";
import { ImageKinds } from "../ImageKinds";
import { AbstractRectangleItem } from "./AbstractRectangleItem";
import { IImageDrawable } from "./IImageDrawable";
import { IQuotable } from "./IQuotable";
import { IClaioSchemaExecutable } from "./IClaioSchemaExecutable";
import { ImageSourceKinds } from "../ImageSourceKinds";

export abstract class AbstractImageDrawableItem extends AbstractRectangleItem implements IImageDrawable, IQuotable, IClaioSchemaExecutable {
  constructor(typeKey: string) {
    super(typeKey);
  }

  public imageSource: IDocumentImageSource = null;
  public originalImageSource: IDocumentImageSource = null;
  public drawLayerImageSource: IDocumentImageSource = null;
  public drawObjectData: string;
  public imageKind: ImageKinds = ImageKinds.Image;
  public claioImageId: string = null;
  public shouldQuote: boolean = false;
  public supportedQuotable: boolean = true;
  public isQuoted: boolean = false;
  public rotationAngle: number = 0;
  public imageDepartmentId: string = null;
  public externalImageId: string = null;

  protected applyMembers(clone: AbstractImageDrawableItem): void {
    super.applyMembers(clone);
    clone.imageSource = this.cloneValue(this.imageSource);
    clone.originalImageSource = this.cloneValue(this.originalImageSource);
    clone.drawLayerImageSource = this.cloneValue(this.drawLayerImageSource);
    clone.drawObjectData = this.cloneValue(this.drawObjectData);
    clone.imageKind = this.cloneValue(this.imageKind);
    clone.claioImageId = this.cloneValue(this.claioImageId);
    clone.shouldQuote = this.cloneValue(this.shouldQuote);
    clone.supportedQuotable = this.cloneValue(this.supportedQuotable);
    clone.isQuoted = this.cloneValue(this.isQuoted);
    clone.rotationAngle = this.cloneValue(this.rotationAngle);
    clone.imageDepartmentId = this.cloneValue(this.imageDepartmentId);
    clone.externalImageId = this.cloneValue(this.externalImageId);
  }

  public clearImageInformation(): void {
    this.claioImageId = null;
    this.imageDepartmentId = null;
    this.imageKind = ImageKinds.Image;
    if (this.originalImageSource) {
      this.originalImageSource.imageGuid = null;
      this.originalImageSource.imageSourceKind = ImageSourceKinds.None;
    }
    if (this.drawLayerImageSource) {
      this.drawLayerImageSource.imageGuid = null;
      this.drawLayerImageSource.imageSourceKind = ImageSourceKinds.None;
    }
    this.drawObjectData = null;
    if (this.imageSource) {
      this.imageSource.imageGuid = null;
      this.imageSource.imageSourceKind = ImageSourceKinds.None;
    }
    this.rotationAngle = 0;
    this.externalImageId = null;
  }

  /**
   * 画像の編集ではなく、別の画像と入れ替えるときは元画像も一緒に更新する
   */
  public replaceImageSource(source: IDocumentImageSource): void {
    this.imageSource = source;
    this.originalImageSource = source;
    if (this.drawLayerImageSource) {
      this.drawLayerImageSource.imageGuid = null;
      this.drawLayerImageSource.imageSourceKind = ImageSourceKinds.None;
    }
    this.drawObjectData = null;
  }

  public get hasImage(): boolean {
    return !!this.imageSource && !!this.imageSource.imageGuid && (this.imageSource.imageSourceKind !== ImageSourceKinds.None);
  }
}
